/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { IPoll } from "@/interfaces/poll/IPoll";
import axios from "axios";

const axiosInstance = axios.create({
    headers: {
        "Access-Control-Allow-Origin": "*"
    }
});

export const poll = {
    state: {
        quantityQuestions: 0,
        questions: [],
        polls: [],
        poll: {},
        questionAndAnswered: [],
        questionsAnswered: [],
        idMedicionAsignada: 0,
        medicionTO: {},
        categories: [],
        idInstitucion: 0,
        information: {},
        answeredSurveys: [],
        notFound: false,
        urlPDF: null
    },
    mutations: {
        SET_QUESTIONS(state: IState, payload: IPoll) {
            state.questions = payload.questions;
        },
        SET_QUESTIONS_ANSWERED(state: IState, payload: IPoll) {
            state.questionsAnswered = [];
            state.questionsAnswered = payload.questionsAnswered;
        },
        SET_QUESTIONS_AND_ANSWER(state: IState, payload: IPoll) {
            state.questionAndAnswered = [];
            state.questionAndAnswered = payload.questionAndAnswered;
        },
        SET_QUANTITY_QUESTIONS(state: IState, payload: IPoll) {
            state.quantityQuestions = payload.quantityQuestions;
        },
        SET_POLLS(state: IState, payload: IPoll) {
            state.polls = payload.polls;
        },
        SET_POLL(state: IState, payload: IPoll) {
            state.questionsAnswered = [];
            state.questionAndAnswered = [];
            state.poll = payload.poll;
        },
        SET_CATEGORIES(state: IState, payload: IPoll) {
            state.categories = payload.categories;
        },
        SET_INFORMATION(state: IState, payload: IPoll) {
            state.information = payload.information;
        },
        SET_ANSWERED_SURVEYS(state: IState, payload: IPoll) {
            let array = [];
            array = state.answeredSurveys;
            array.push(payload.surveys)
            state.answeredSurveys = array;
        },
        NOT_FOUND(state: IState, payload: IPoll) {
            state.notFound = payload.notFound;
        },
        SET_ID_INSTITUTION(state: IState, payload: IPoll) {
            state.institutionId = payload.idInstitucion;
        },
        SET_URL_PDF(state: IState, payload: IPoll) {
            state.urlPDF = payload.urlPDF;
        }
    },
    actions: {
        setQuestionAndAnswered(context: any, payload: IPoll) {
            context.commit("SET_QUESTIONS_AND_ANSWER", payload);
        },
        setQuestionsAnswered(context: any, payload: IPoll) {
            context.commit("SET_QUESTIONS_ANSWERED", payload);
        },
        setQuantityQuestions(context: any, payload: IPoll) {
            context.commit("SET_QUANTITY_QUESTIONS", payload);
        },
        async searchPoll(context: any, payload: IPoll) {
            return await axiosInstance.get(`${axios.defaults.baseURL}/roma-entrevista/encuesta/${payload}`)
                .then(response => {
                    if (response !== null && response.status === 200) {
                        const arrayPoll: any = [];
                        arrayPoll.push(response.data)
                        context.commit("SET_POLLS", { polls: arrayPoll })
                        return response;
                    } else {
                        return null;
                    }

                })
                .catch(error => {
                    console.info(error)
                    return 400;
                });
        },
        async setInformation(context: any, payload: IPoll) {
            context.commit("SET_ID_INSTITUTION", { idInstitucion: 0 });
            return await axiosInstance.get(`${axios.defaults.baseURL}/roma-entrevista/institution/${payload.idInstitucion}`)
                .then(response => {
                    const infoGeneral = {
                        identificationCode: response.data.identificationCode,
                        implementer: response.data.implementer,
                        institutionId: response.data.institutionId,
                        name: response.data.name,
                        school: true,
                        timeZone: response.data.timeZone,
                        yearSelected: response.data.yearSelected,
                    };
                    context.commit("SET_INFORMATION", { information: infoGeneral });
                    context.commit("SET_CATEGORIES", { categories: response.data.categories });
                    context.commit("SET_ID_INSTITUTION", { idInstitucion: response.data.institutionId });
                    return response;
                })
                .catch(error => {
                    console.info(error.message)
                });
        },
        setPoll(context: any, payload: IPoll) {
            context.commit("SET_POLL", payload)
        },
        setQuestion(context: any, payload: IPoll) {
            context.commit("SET_QUESTIONS", payload)
        },
        async sendPoll(context: any, payload: IPoll) {
            return await axiosInstance.post(`${axios.defaults.baseURL}/roma-entrevista/answers`, payload.answers)
                .then(response => {
                    context.commit("SET_QUESTIONS_ANSWERED", { questionsAnswered: [] });
                    context.commit("SET_QUESTIONS", { questions: [] });
                    context.commit("SET_QUESTIONS_AND_ANSWER", { questionAndAnswered: [] });
                    console.log(payload.answers.idMedicionAsignada)
                    context.commit("SET_ANSWERED_SURVEYS", { surveys: payload.answers.idMedicionAsignada })
                    return response;
                })
                .catch(error => {
                    console.info(error)
                });
        },
        setNotFound(context: any, payload: IPoll) {
            context.commit("NOT_FOUND", payload);
        },
        async setUrlPDF(context: any, payload: IPoll) {
            console.log(payload)
            return await axiosInstance.get(`https://dev.romaevalua.cl/pdf/${payload.idMedicion}`)
                .then(data => {
                    return data;
                    console.log(data)
                })
        },
        reset(context: any) {
            context.commit("SET_QUESTIONS_ANSWERED", { questionsAnswered: [] });
            context.commit("SET_QUESTIONS", { questions: [] });
            context.commit("SET_QUESTIONS_AND_ANSWER", { questionAndAnswered: [] });
            context.commit("SET_INFORMATION", { information: {} });
            context.commit("SET_ID_INSTITUTION", { idInstitucion: 0 });
            context.commit("NOT_FOUND", { notFound: true });
        }
    },
    getters: {
        getQuestions(state: IState) {
            return state.questions;
        },
        getQuestionsAnswered(state: IState) {
            return state.questionsAnswered;
        },
        getQuestionsAndAnswered(state: IState) {
            return state.questionAndAnswered;
        },
        getquantityQuestions(state: IState) {
            return state.quantityQuestions;
        },
        getCategories(state: IState) {
            return state.categories;
        },
        getPoll(state: IState) {
            return state.poll;
        },
        getInformation(state: IState) {
            return state.information;
        },
        getAnsweredSurveys(state: IState) {
            return state.answeredSurveys;
        },
        getNotFound(state: IState) {
            return state.notFound;
        }
    }
};


